import React, { useState, useEffect, useCallback } from 'react';
import { accountingAPI } from '../../../services/api';
import { AccountingList } from './AccountingList';
import { StatCard } from '../../../components/common/StatCard';
import { PageHeader } from '../../../components/layout/PageHeader';
import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

export function SalesPage() {
  const [records, setRecords]     = useState([]);
  const [pagination, setPg]       = useState(null);
  const [loading, setLoading]     = useState(true);
  const [page, setPage]           = useState(1);
  const [search, setSearch]       = useState('');
  const [statusFilter, setSt]     = useState('');
  
  const [totals, setTotals]       = useState({ count:0, total:0, paid:0, pending:0 });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await accountingAPI.getAll({
        type: 'sale',
        status: statusFilter || undefined,
        page,
        limit: 15,
      });
      const data = res.data || [];
      setRecords(data);
      setPg(res.pagination);
      const tot  = data.reduce((s,r) => s + Number(r.total||0), 0);
      const paid = data.filter(r => r.status==='paid').reduce((s,r) => s+Number(r.total||0),0);
      const pend = data.filter(r => ['draft','pending'].includes(r.status)).reduce((s,r)=>s+Number(r.total||0),0);
      setTotals({ count: res.pagination?.total||0, total: tot, paid, pending: pend });
    } catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, [statusFilter, page]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5">
      <PageHeader title="Sales" subtitle="Outgoing invoices and sales transactions"/>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard title="Records"  value={loading?'...':totals.count}                              icon={ArrowUpCircleIcon} color="green"/>
        <StatCard title="Value"    value={loading?'...':('₹'+(totals.total/1000).toFixed(0)+'K')}  icon={ArrowUpCircleIcon} color="green"/>
        <StatCard title="Paid"     value={loading?'...':('₹'+(totals.paid/1000).toFixed(0)+'K')}   icon={ArrowUpCircleIcon} color="green"/>
        <StatCard title="Pending"  value={loading?'...':('₹'+(totals.pending/1000).toFixed(0)+'K')} icon={ArrowUpCircleIcon} color="amber"/>
      </div>
      
      <AccountingList
        type={'sale'}
        title="Sales"
        records={records}
        loading={loading}
        pagination={pagination}
        onPageChange={setPage}
        onRefresh={load}
        search={search}
        setSearch={setSearch}
        statusFilter={statusFilter}
        setStatusFilter={setSt}
      />
    </div>
  );
}